/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Subtitle_Exported_Saved_MessageInputs */



/**
* | output |
* | --- |
* | "Subtitle exported and saved successfully" |
*
* @param {Iframe_Remote_Subtitle_Exported_Saved_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_subtitle_exported_saved_message = /** @type {((inputs?: Iframe_Remote_Subtitle_Exported_Saved_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Subtitle_Exported_Saved_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titres exportes et enregistres avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel erfolgreich exportiert und gespeichert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitolo esportato e salvato correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Субтитры успешно экспортированы и сохранены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtítulo exportado y guardado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕已成功导出并保存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕のエクスポートと保存に成功しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक सफलतापूर्वक निर्यात और सहेज लिए गए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legenda exportada e salva com sucesso.")
	return /** @type {LocalizedString} */ ("Subtitle exported and saved successfully")
});